import { useState, useEffect, useMemo } from 'react';
import { debounce } from 'lib';

export function useWindowDimension() {
  const [dimension, setDimension] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const debouncedResizeHandler = useMemo(() => {
    return debounce(() => {
      setDimension({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }, 300);
  }, []);

  useEffect(() => {
    window.addEventListener('resize', debouncedResizeHandler);
    return () => window.removeEventListener('resize', debouncedResizeHandler);
  }, []);
  return dimension;
}
